import React, { memo } from 'react'
import { ContractorNote } from 'src/interfaces/note'
import tw from 'twin.macro'
import { ContractorNoteItem } from './ContractorNoteItem'
import { CreateContractorNoteButton } from './CreateContractorNoteButton'
import useCheckPermissions from 'src/hooks/useCheckPermissions'
import { UserPermission } from 'src/constants/user'

interface Props {
  contractorNotes: Array<ContractorNote>
  contractorId: string
  refreshContractorNotes(): Promise<void>
}

const NotesListComponent = ({ contractorNotes, contractorId, refreshContractorNotes }: Props) => {
  const { hasPermission } = useCheckPermissions()

  return (
    <div css={tw`bg-white rounded-2xl px-4 py-3.5 overflow-hidden`}>
      <div css={tw`mb-4`}>
        {hasPermission(UserPermission.ContractorNotesCreate) && (
          <CreateContractorNoteButton
            contractorId={contractorId}
            refreshContractorNotes={refreshContractorNotes}
          />
        )}
      </div>
      {contractorNotes.map((contractorNote) => (
        <ContractorNoteItem
          key={contractorNote.id}
          contractorNote={contractorNote}
          contractorId={contractorId}
          refreshContractorNotes={refreshContractorNotes}
        />
      ))}
    </div>
  )
}

export const NotesList = memo(NotesListComponent)
